import BackIcon from '@/images/h5-self-service/back.webp';
import { ReactNode } from 'react';
import IconShare from '@/images/h5-common/icon_share.webp';
import IconBack from '@/images/h5-common/icon_back.webp';

// Header高度相关常量
const HEADER_PADDING = 14; // 头部内边距
const BUTTON_HEIGHT = 30; // 按钮高度
const BUTTON_WIDTH = 55; // 按钮宽度
const PLACEHOLDER_HEIGHT = 58; // 固定定位时的占位高度

interface HeaderProps {
  onClickBack?: () => void;
  title?: string | ReactNode;
  leftBtn?: string | ReactNode;
  rightBtn?: string | ReactNode;
  isShowBack?: boolean;
  isNeedFixedTop?: boolean;
  headerBgColor?: string;
  className?: string;
  titleLeftAlign?: boolean;
}

function Header({
  title = '',
  onClickBack,
  leftBtn,
  rightBtn,
  isShowBack = true,
  isNeedFixedTop = false,
  headerBgColor = '',
  className,
  titleLeftAlign = false,
}: HeaderProps) {
  return (
    <>
      <div
        className={`${
          isNeedFixedTop ? 'fixed top-0 left-0 w-full' : ''
        } flex ${titleLeftAlign ? 'justify-start' : 'justify-between'} items-center z-[999] ${className}`}
        style={{ 
          background: headerBgColor,
          padding: `${HEADER_PADDING}px`
        }}
      >
        <div 
          className='flex items-center'
          style={{ 
            width: titleLeftAlign ? 'auto' : `${BUTTON_WIDTH}px`, 
            height: `${BUTTON_HEIGHT}px` 
          }}
        >
          {isShowBack ? (
            leftBtn != null ? (
              leftBtn
            ) : (
              <img
                onClick={onClickBack}
                src={IconBack}
                alt=''
                style={{ 
                  width: `${BUTTON_HEIGHT}px`, 
                  height: `${BUTTON_HEIGHT}px` 
                }}
              />
            )
          ) : (
            <></>
          )}
        </div>
        
        {titleLeftAlign ? (
          <>
            <div
              className={`text-[#493414] text-[18px] font-semibold ml-2 flex-1 flex items-center`}
            >
              {title}
            </div>
            <div 
              className='flex items-center text-[14px] justify-end'
              style={{ 
                height: `${BUTTON_HEIGHT}px` 
              }}
            >
              {rightBtn}
            </div>
          </>
        ) : (
          <>
            <div
              className={`text-[#493414] text-[18px] font-semibold text-center truncate flex-1`}
            >
              {title}
            </div>
            <div 
              className='flex items-center text-[14px] justify-end'
              style={{ 
                height: `${BUTTON_HEIGHT}px` 
              }}
            >
              {rightBtn}
            </div>
          </>
        )}
      </div>
      {isNeedFixedTop ? (
        <div style={{ minHeight: `${PLACEHOLDER_HEIGHT}px` }}></div>
      ) : null}
    </>
  );
}

export default Header;
